import React, { useContext, useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);
  const id = props.id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [iconPreview, setIconPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // ✅ keep real file here

  // 🔹 Handle file change and preview
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setIconPreview(URL.createObjectURL(file));
    }
  };

  // 🔹 Fetch existing data when editing
  const GetEditData = async () => {
    if (!id) return;
    const response = await getData(`/masters/bank-detail/${id}`);
    if (response?.data) {
      reset(response.data);
      if (response.data.icon) {
        setIconPreview(IMG_URL + response.data.icon);
      }
    }
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  // 🔹 Handle submit using FormData
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      // append all text fields
      for (const key in data) {
        if (key !== "icon" && data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      }

      // append file only if new one selected
      if (selectedFile) {
        formData.append("icon", selectedFile);
      }

      const response = id
        ? await postData(`/masters/bank-detail/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        : await postData(`/masters/bank-detail`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log("Error submitting form:", error);
    }
  };

  const errorStyle = { color: "red", marginLeft: "5px" };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>{id ? "Edit Bank" : "Add Bank"}</Card.Title>
              <hr />
              <Container>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md={12}>
                      <Container>
                        <Row>
                          <Col xxl={12} xl={12} md={12}>
                            <Form className="AppSetupclass">
                              <Row>
                                <Col
                                  lg={12}
                                  md={12}
                                  className="mx-auto Add-content"
                                >
                                  <Row>
                                    <h5><b>Bank Details</b></h5>

                                    {/* Bank Name */}
                                    <Col md={3}>
                                      <Form.Label>Bank Name</Form.Label>
                                      <Form.Control
                                        type="text"
                                        {...register("bank_name", {
                                          required: "Bank Name is required",
                                        })}
                                        className={`form-control ${errors.bank_name ? "is-invalid" : ""}`}
                                        placeholder="Bank Name"
                                      />
                                      {errors.bank_name && (
                                        <span style={errorStyle}>{errors.bank_name.message}</span>
                                      )}
                                    </Col>

                                    {/* Firm Name */}
                                    <Col md={3}>
                                      <Form.Label>Firm Name</Form.Label>
                                      <Form.Control
                                        type="text"
                                        {...register("firm_name", {
                                          required: "Firm Name is required",
                                        })}
                                        className={`form-control ${errors.firm_name ? "is-invalid" : ""}`}
                                        placeholder="Firm Name"
                                      />
                                      {errors.firm_name && (
                                        <span style={errorStyle}>{errors.firm_name.message}</span>
                                      )}
                                    </Col>

                                    {/* A/c No */}
                                    <Col md={3}>
                                      <Form.Label>A/c No</Form.Label>
                                      <Form.Control
                                        type="number"
                                        {...register("ac_no", {
                                          required: "A/c No is required",
                                        })}
                                        className={`form-control ${errors.ac_no ? "is-invalid" : ""}`}
                                        placeholder="A/c No"
                                      />
                                      {errors.ac_no && (
                                        <span style={errorStyle}>{errors.ac_no.message}</span>
                                      )}
                                    </Col>

                                    {/* IFSC Code */}
                                    <Col md={3}>
                                      <Form.Label>IFSC Code</Form.Label>
                                      <Form.Control
                                        type="text"
                                        {...register("ifsc_code", {
                                          required: "IFSC Code is required",
                                        })}
                                        className={`form-control ${errors.ifsc_code ? "is-invalid" : ""}`}
                                        placeholder="IFSC Code"
                                      />
                                      {errors.ifsc_code && (
                                        <span style={errorStyle}>{errors.ifsc_code.message}</span>
                                      )}
                                    </Col>

                                    {/* Text Color */}
                                    <Col md={3}>
                                      <Form.Label>Text Color</Form.Label>
                                      <Form.Control
                                        type="color"
                                        {...register("text_color")}
                                        className="form-control form-control-color"
                                      />
                                    </Col>

                                    {/* Background Color */}
                                    <Col md={3}>
                                      <Form.Label>Background Color</Form.Label>
                                      <Form.Control
                                        type="color"
                                        {...register("background_color")}
                                        className="form-control form-control-color"
                                      />
                                    </Col>

                                    {/* Icon Upload */}
                                    <Col md={3}>
                                      <Form.Label>Icon</Form.Label>
                                      <Form.Control
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                      />
                                      {iconPreview && (
                                        <div className="mt-2 text-center">
                                          <img
                                            src={iconPreview}
                                            alt="Preview"
                                            style={{
                                              width: 60,
                                              height: 60,
                                              borderRadius: "50%",
                                            }}
                                          />
                                        </div>
                                      )}
                                    </Col>
                                  </Row>

                                  <hr />
                                  <Row className="pb-3">
                                    <div className="d-flex justify-content-center">
                                      <Link>
                                        <CancelButton
                                          name="cancel"
                                          handleClose={props.handleClose}
                                        />
                                      </Link>
                                      <SaveButton
                                        name="save"
                                        handleSubmit={handleSubmit(onSubmit)}
                                      />
                                    </div>
                                  </Row>
                                </Col>
                              </Row>
                            </Form>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
